import { __rest } from "tslib";
import * as React from 'react';
import { createPortal } from 'react-dom';
import { Snackbar as UISnackbar } from '@material-ui/core';
import { useIsMobile } from '../../../../utils';
import Content from '../Content/Content';
const Snackbar = (_a) => {
    var { type, title, text, renderButton, onClose } = _a, snackbarProps = __rest(_a, ["type", "title", "text", "renderButton", "onClose"]);
    const isMobile = useIsMobile();
    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        onClose();
    };
    return createPortal(React.createElement(UISnackbar, Object.assign({ autoHideDuration: 4000, anchorOrigin: isMobile ? { vertical: 'top', horizontal: 'center' } : { vertical: 'top', horizontal: 'right' }, onClose: handleSnackbarClose }, snackbarProps),
        React.createElement(Content, { type: type, title: title, text: text, renderButton: renderButton, onClose: onClose })), document.body);
};
export default Snackbar;
